class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.isFullWidth = this.item.closest('.product-full-width').length == 1 || this.item.closest('.product-full-width-2').length == 1;

        this.onVariantInit();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantInit(){
        this.updateOptions();
        this.resolveHiddenOptionSelections();
        this.updateOptions();
        this.updateMasterId();

        // Stock check and dropdown management
        this.checkStockAndDisableDropdowns();

        const hasMultipleOptions = [...this.querySelectorAll('.product-form__input')]
            .filter(w => !(w.offsetParent === null || window.getComputedStyle(w).display === 'none'))
            .length > 1;

        if (!this.currentVariant?.id) {
            this.updateAttribute(true);
            
            if(this.item.find('[data-barcode]').length > 0) this.item.find('[data-barcode]').hide();
            if(this.item.find('[data-inventory]').length > 0) this.item.find('[data-inventory]').hide();

            document.getElementById(`product-price-${this.dataset.product}`)?.classList.add('visibility-hidden');
            if (this.item.find('.productView-subtotal').length > 0) this.item.find('.productView-subtotal').hide();

            const propId = `#product-property-${this.dataset.product}`;
            if (this.item.find(propId).length > 0) this.item.find(propId).hide();

            // Hide SKU and inner dimensions for multi-option products until a variant is selected
            if (hasMultipleOptions) {
                if (this.item.find('[data-sku]').length > 0) this.item.find('[data-sku]').hide();
                if (this.item.find('[data-inner-dim]').length > 0) this.item.find('[data-inner-dim]').hide();
            }
        } else {
            this.updateMedia(1500, 'init');
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);

            if (this.item.find('.productView-subtotal').length > 0) this.item.find('.productView-subtotal').show();
            const propId = `#product-property-${this.dataset.product}`;
            if (this.item.find(propId).length > 0) this.item.find(propId).show();

            // Show SKU and inner dimensions for multi-option products when a valid variant is selected
            if (hasMultipleOptions) {
                if (this.item.find('[data-sku]').length > 0) this.item.find('[data-sku]').show();
                // Inner dimensions are managed by value inside renderProductInfo
            }
        }
        this.updateVariantStatuses();
        this.updateOptionLabelsByMetafield();
        this.enforceSelectionOrder();
        this.dispatchVariantState();
    }
    
    onVariantChange(event) {
        this.updateOptions();
        const wrappers = this.getVisibleOptionWrappers();
        const changedWrapper = event?.target ? event.target.closest('.product-form__input') : null;
        const changedIndex = changedWrapper ? wrappers.indexOf(changedWrapper) : -1;

        if (changedIndex > -1) {
            this.clearFollowingOptionsFrom(changedIndex);
        }

        this.updateOptions();
        this.resolveHiddenOptionSelections();
        this.updateOptions();
        this.updateMasterId();
        this.enforceSelectionOrder();

        this.updateVariantStatuses();
        this.updateOptionLabelsByMetafield();

        const hasMultipleOptions = [...this.querySelectorAll('.product-form__input')]
            .filter(w => !(w.offsetParent === null || window.getComputedStyle(w).display === 'none'))
            .length > 1;

        if (!this.currentVariant?.id) {
            this.updateAttribute(true);
            this.updateStickyAddToCart(true);

            document.getElementById(`product-price-${this.dataset.product}`)?.classList.add('visibility-hidden');
            
            if(this.item.find('[data-barcode]').length > 0) this.item.find('[data-barcode]').hide();
            if(this.item.find('[data-inventory]').length > 0) this.item.find('[data-inventory]').hide();
            if (this.item.find('.productView-subtotal').length > 0) this.item.find('.productView-subtotal').hide();
            const propId2 = `#product-property-${this.dataset.product}`;
            if (this.item.find(propId2).length > 0) this.item.find(propId2).hide();
            // Hide SKU and inner dimensions for multi-option products until a variant is selected
            if (hasMultipleOptions) {
                if (this.item.find('[data-sku]').length > 0) this.item.find('[data-sku]').hide();
                if (this.item.find('[data-inner-dim]').length > 0) this.item.find('[data-inner-dim]').hide();
            }
        } else {
            this.updateMedia(200, 'change');
            if (!document.querySelector('.featured-product')) {
                this.updateURL();
            }
            this.updateVariantInput();
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
            this.updateStickyAddToCart(false, !this.currentVariant.available);
            this.checkQuantityWhenVariantChange();

            
            if(this.item.find('[data-barcode]').length > 0) this.item.find('[data-barcode]').show();
            if(this.item.find('[data-inventory]').length > 0) this.item.find('[data-inventory]').show();
            if (this.item.find('.productView-subtotal').length > 0) this.item.find('.productView-subtotal').show();
            const propId3 = `#product-property-${this.dataset.product}`;
            if (this.item.find(propId3).length > 0) this.item.find(propId3).show();

            // Show SKU and inner dimensions for multi-option products when a valid variant is selected
            if (hasMultipleOptions) {
                if (this.item.find('[data-sku]').length > 0) this.item.find('[data-sku]').show();
                // Inner dimensions are managed by value inside renderProductInfo
            }
        }
        this.enforceSelectionOrder();
        this.dispatchVariantState();
    }

    updateOptions() {
        this.options = this.getAllOptionWrappers().map((wrapper) => this.getWrapperSelectedValue(wrapper) || '');
    }

    getAllOptionWrappers() {
        return Array.from(this.querySelectorAll('.product-form__input'))
            .sort((a, b) => this.getWrapperOptionIndex(a) - this.getWrapperOptionIndex(b));
    }

    getVisibleOptionWrappers() {
        return this.getAllOptionWrappers().filter((wrapper) => this.isWrapperVisible(wrapper));
    }

    isWrapperVisible(wrapper) {
        return !(wrapper.offsetParent === null || window.getComputedStyle(wrapper).display === 'none');
    }

    getWrapperOptionIndex(wrapper) {
        return parseInt(wrapper?.dataset?.optionIndex || '0', 10);
    }

    getWrapperSelectedValue(wrapper) {
        const sel = wrapper?.querySelector('select');

        if (sel) {
            return sel.value || '';
        }

        const checked = wrapper?.querySelector('input[type="radio"]:checked');
        return checked ? this.decodeOption(checked.value) : '';
    }

    getWrapperPreferredValue(wrapper) {
        return wrapper?.dataset?.defaultOptionValue || '';
    }

    shouldResolveHiddenWrapper(wrapper) {
        return wrapper?.dataset?.hiddenOption === 'true' && wrapper?.dataset?.hiddenResolution === 'preferred_only';
    }

    getSelectionConstraints({ useImplicitHiddenDefaults = false } = {}) {
        return this.getAllOptionWrappers().map((wrapper) => {
            const selectedValue = this.getWrapperSelectedValue(wrapper);

            if (selectedValue) {
                return selectedValue;
            }

            if (useImplicitHiddenDefaults && this.shouldResolveHiddenWrapper(wrapper)) {
                return this.getWrapperPreferredValue(wrapper);
            }

            return '';
        });
    }

    variantMatchesSelections(variant, selections, { skipIndex = null, availableOnly = false } = {}) {
        if (!variant) return false;
        if (availableOnly && !variant.available) return false;

        return (variant.options || []).every((optionValue, index) => {
            if (skipIndex !== null && index === skipIndex) {
                return true;
            }

            const expectedValue = selections[index];
            return !expectedValue || expectedValue === optionValue;
        });
    }

    getMatchingVariants(selections, { skipIndex = null, availableOnly = false } = {}) {
        return this.getVariantData().filter((variant) =>
            this.variantMatchesSelections(variant, selections, { skipIndex, availableOnly })
        );
    }

    setWrapperSelectedValue(wrapper, value) {
        const normalizedValue = this.decodeOption(value);
        const select = wrapper?.querySelector('select');

        if (select) {
            const matchingOption = Array.from(select.options).find((option) => option.value === normalizedValue);

            if (!matchingOption) {
                return false;
            }

            select.value = matchingOption.value;
            this.syncWrapperUI(wrapper);
            return true;
        }

        const radios = Array.from(wrapper?.querySelectorAll('input[type="radio"]') || []);
        const matchingRadio = radios.find((radio) => this.decodeOption(radio.value) === normalizedValue);

        if (!matchingRadio) {
            return false;
        }

        radios.forEach((radio) => {
            radio.checked = radio === matchingRadio;
        });

        return true;
    }

    clearWrapperSelection(wrapper) {
        const select = wrapper?.querySelector('select');

        if (select) {
            select.value = '';
            this.syncWrapperUI(wrapper);
            return;
        }

        wrapper?.querySelectorAll('input[type="radio"]').forEach((radio) => {
            radio.checked = false;
        });
    }

    resolveHiddenOptionSelections() {
        const wrappers = this.getAllOptionWrappers();

        wrappers.forEach((wrapper) => {
            if (!this.shouldResolveHiddenWrapper(wrapper)) {
                return;
            }

            const optionIndex = this.getWrapperOptionIndex(wrapper);
            const preferredValue = this.getWrapperPreferredValue(wrapper);

            if (!preferredValue) {
                this.clearWrapperSelection(wrapper);
                return;
            }

            const selections = this.getSelectionConstraints({ useImplicitHiddenDefaults: true });
            selections[optionIndex] = preferredValue;

            const hasAvailablePreferredVariant = this.getMatchingVariants(selections, { availableOnly: true }).length > 0;

            if (hasAvailablePreferredVariant) {
                this.setWrapperSelectedValue(wrapper, preferredValue);
            } else {
                this.clearWrapperSelection(wrapper);
            }
        });
    }

    isWrapperSelected(wrap) {
        const sel = wrap?.querySelector('select');
        if (sel) return !!sel.value;
        const checked = wrap?.querySelector('input[type="radio"]:checked');
        return !!checked;
    }

    syncWrapperUI(wrap) {
        const sel = wrap?.querySelector('select');
        if (sel) {
            sel.dispatchEvent(new CustomEvent('dropdown:options-updated'));
        }
    }

    dispatchVariantState() {
        try {
            const productId = this.dataset.product || null;
            const isSelected = !!this.currentVariant?.id;
            window.dispatchEvent(new CustomEvent('variant:status', {
                detail: { isSelected, variant: isSelected ? this.currentVariant : null, options: this.options, productId }
            }));
            if (!isSelected) {
                window.dispatchEvent(new CustomEvent('variant:partial', {
                    detail: { options: this.options, productId }
                }));
            }
        } catch (e) { /* no-op */ }
    }

    enforceSelectionOrder() {
        const wrappers = this.getVisibleOptionWrappers();

        wrappers.forEach((wrap, idx) => {
            const enabled = idx === 0 || this.isWrapperSelected(wrappers[idx - 1]);
            this.setWrapperEnabled(wrap, enabled);
        });
    }

    setWrapperEnabled(wrap, enabled) {
        const sel = wrap.querySelector('select');
        if (sel) {
            sel.disabled = !enabled;
            return;
        }
        const radios = wrap.querySelectorAll('input[type="radio"]');
        if (radios.length) {
            radios.forEach(r => {
                r.disabled = !enabled;
            });
        }
    }

    clearFollowingOptionsFrom(startIdx) {
        const wrappers = this.getVisibleOptionWrappers();

        for (let i = startIdx + 1; i < wrappers.length; i++) {
            const wrap = wrappers[i];
            const sel = wrap.querySelector('select');

            if (sel) {
                if (sel.value) {
                    sel.value = '';
                    this.syncWrapperUI(wrap);
                }
            } else {
                const radios = wrap.querySelectorAll('input[type="radio"]');
                radios.forEach(r => {
                    if (r.checked) r.checked = false;
                });
            }
        }
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }
    
    updateMasterId() {
        this.decodeOptions();
        const variants = this.getVariantData();

        // Are all visible variant groups that the customer must select complete?
        const visibleWrappers = this.getVisibleOptionWrappers();
        const visibleSelectedAll = visibleWrappers.every((wrapper) => !!this.getWrapperSelectedValue(wrapper));

        let found = null;
        if (visibleSelectedAll) {
            // Look for an exact match once all visible selections are complete
            found = variants.find(variant => {
                const opts = variant.options || [];
                return !opts.map((opt, idx) => this.options[idx] === opt).includes(false);
            }) || null;
        }

        this.currentVariant = found || {};
        // Current variant ID has been updated

        if (this.item.find('[data-filter]').length && this.currentVariant?.featured_media && this.currentVariant.featured_media.alt != null) {
            this.item.find('[data-filter]:checked').attr('data-value-default-lang', this.currentVariant?.featured_media.alt.toLowerCase().replace(/ /g,"-"));
        }
    }      

    updateMedia(time, status) {
        const enableVariantImageGroup = document?.querySelector('.enable_variant_image_group');
    
        if (enableVariantImageGroup && status == 'init') return;

        setTimeout(() => {
            if (!this.currentVariant || !this.currentVariant?.featured_media || document.querySelector('.productView-nav')?.matches('.media-filter')) return;
            
            const newMedia = document.querySelectorAll(
                `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
            );
    
            if (!newMedia) return;
            window.setTimeout(() => {
                $(newMedia).trigger('click');
            }, time);
    
            if (!this.isFullWidth || window.innerWidth < 768 || !this.currentVariant) return;
            const mediaId = this.currentVariant.featured_media.id;
            const activeMedia = document?.querySelector(`.product-single__media[data-media-id="${mediaId}"]`);
            const fallbackImageContainer = document?.querySelector('.productView-image[data-index="1"]');

            if (activeMedia) {
                setTimeout(() => {
                    activeMedia.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 20);
            } else {
                const fallbackImage = fallbackImageContainer?.querySelector('img');
                const featuredImage = this.currentVariant?.featured_image;
                if (!featuredImage || !fallbackImage) return;

                fallbackImage.setAttribute('src', featuredImage.src);
                fallbackImage.setAttribute('srcset', featuredImage.src);
                fallbackImage.setAttribute('alt', featuredImage.alt);

                setTimeout(() => {
                    fallbackImageContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 20);
            }
        }, 1)
    }

    scrollToBlock(block) {
        const headerHeight = document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height 
        const announcementBarHeight = document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height 
        const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight 

        window.scrollTo({
            top: positionTop,
            behavior: 'smooth'
        })
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`);

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }


    renderProductAjaxInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                const property = `product-property-${this.dataset.product}`;
                const destinationProperty = document.getElementById(property);
                const sourceProperty = html.getElementById(property);

                // Copy/update the inner dimensions metafield by variant
                const destinationVariantMetafield = this.item[0]?.querySelector('[data-inner-dim]');
                const sourceVariantMetafield = html.querySelector('[data-inner-dim]');
                if (sourceVariantMetafield && destinationVariantMetafield) {
                    destinationVariantMetafield.innerHTML  = sourceVariantMetafield.innerHTML;

                    const hasValue = sourceVariantMetafield.querySelector('.productView-info-value')?.textContent?.trim()?.length > 0;
                    destinationVariantMetafield.style.display = hasValue ? '' : 'none';
                }

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                if(destinationProperty) {
                    if (sourceProperty) {
                        destinationProperty.innerHTML = sourceProperty.innerHTML;
                        destinationProperty.style.display = 'table';
                    } else{
                        destinationProperty.style.display = 'none';
                    }
                } else if (sourceProperty) {
                    document.querySelector('.productView-product').insertBefore(sourceProperty, document.querySelector('.productView-options'));
                }

                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
                this.updateBadgeSale()
        });
    }

    renderProductInfo() {

        // Dynamically update box inner dimensions (data-inner-dim) by variant
        if(this.item.find('[data-inner-dim]').length > 0){
            const $innerDim = this.item.find('[data-inner-dim]');
            const $innerDimName = $innerDim.find('.productView-info-name');
            const $innerDimValue = $innerDim.find('.productView-info-value');

            // Metafield value priority: master_data > variant_ic_olcu
            const getInnerDim = () => {
                const v = this.currentVariant || {};
                const mf = v.metafields?.custom || {};
                const md = mf.master_data;
                if (md) {
                    const obj = md.value || md;
                    const key = 'variant_ic_olcu';
                    const val = obj?.[key] || obj?.variant_ic_olcu;
                    if (typeof val === 'string' && val.trim().length > 0) return val.trim();
                }
                const fallback = mf?.variant_ic_olcu;
                if (typeof fallback === 'string' && fallback.trim().length > 0) return fallback.trim();
                return '';
            };

            const innerDimText = getInnerDim();

            if (innerDimText) {
                $innerDimValue.text(innerDimText);
                $innerDim.show();
                $innerDimName.show();
                $innerDimValue.show();
            } else {
                // Hide the block and heading if there is no value
                $innerDim.hide();
                $innerDimName.hide();
                $innerDimValue.hide();
            }
        }

        if(this.item.find('[data-barcode]').length > 0){
            this.item.find('[data-barcode] .productView-info-value').text(this.currentVariant.barcode);
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inputQuantity = this.item.find('input[name="quantity"]'),
                    buttonSubmit = this.item.find('button#product-add-to-cart'),
                    inventoryQuantity = parseInt(inven_num);

                if(inputQuantity.length > 0) {
                    inputQuantity.attr('data-inventory-quantity', inventoryQuantity);
                } else {
                    buttonSubmit.attr('data-inventory-quantity', inventoryQuantity);
                }

                if(this.item.find('[data-inventory]').length > 0){
                    if(inventoryQuantity > 0){
                        const showStock = this.item.find('[data-inventory]').data('stock-level');
                        if (showStock == 'show') {
                            this.item.find('[data-inventory] .productView-info-value').text(inventoryQuantity+' '+window.inventory_text.inStock);
                        }
                        else {
                            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
                        }
                    } else {
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
                    }
                }
            }
        }

        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const optionSticky = sticky.find('variant-sticky-selects .select__select').first();

            if (optionSticky.length) {
                optionSticky.val(this.currentVariant.id);
            }
        }
    }

    updateProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const description = `[data-product-description-${this.dataset.product}]`
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destinationDesc = document.querySelector(description);
                const sourceDesc = html.querySelector(description);

                if (sourceDesc && destinationDesc) {
                    destinationDesc.innerHTML = sourceDesc.innerHTML;
                    if (destinationDesc.closest('.toggle-content--height')){
                        destinationDesc.style.maxHeight = null;
                    }
                }
        });
    }

    updateAttribute(unavailable = true, disable = true){
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        const dynamicCheckoutWrapper = this.item.find('[data-dynamic-checkout-wrapper]');
        var quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.productView-notifyMe'),
            buttonAddtocart = this.item.find('.product-form__submit'),
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

        if (isNaN(maxValue)) {
            maxValue = maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
        } else {
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
        }
        
        if(unavailable){
            var text;

            // If there is no selected variant yet, show a friendly placeholder message
            if (!this.currentVariant?.id) {
                text = window.variantStrings?.selectVariant || window.variantStrings?.select || 'Please select a variant';
            } else {
                text = window.variantStrings.unavailable;
            }

            quantityInput.attr('disabled', true);
            notifyMe.slideUp('slow');
            if (!this.currentVariant?.id && dynamicCheckoutWrapper.length) {
                dynamicCheckoutWrapper.hide();
            }
            if (addButton != null){
                addButton.setAttribute('disabled', true);
                addButton.textContent = text;
            }
            quantityInput.closest('quantity-input').addClass('disabled');
            
        } else {
            if (disable) {
                var text = window.variantStrings.soldOut,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }
                    } else if (window.subtotal.style == '2') {
                        text = window.subtotal.text.replace('[value]', subTotal);
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', true);
                if (dynamicCheckoutWrapper.length) {
                    dynamicCheckoutWrapper.show();
                }
                if (addButton != null){
                    addButton.setAttribute('disabled', true);
                    addButton.textContent = text;
                }
                quantityInput.closest('quantity-input').addClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.find('.kutufix-notify-product-variant').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.slideDown('slow');
                }
            } else {
                var text,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }

                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.variantStrings.addToCart;
                        }
                    } else if (window.subtotal.style == '2') {
                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.subtotal.text.replace('[value]', subTotal);
                            $('#show-sticky-product').text(text);
                            $('#product-sticky-add-to-cart').text(text);
                        }
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', false);
                if (dynamicCheckoutWrapper.length) {
                    dynamicCheckoutWrapper.show();
                }
                if (addButton != null){
                    addButton.removeAttribute('disabled');
                    addButton.textContent = text;
                }
                quantityInput.closest('quantity-input').removeClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                            
                            const compare_at_price_sticky = Shopify.formatMoney(compare_at_price, window.money_format);
                            const comparePrice_sticky = extractContent(compare_at_price_sticky);
                            thisComparePrice.text(comparePrice_sticky);
                            
                            if (this.checkNeedToConvertCurrency()) {
                                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                            }

                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                            thisComparePrice.remove();
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');
                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.slideUp('slow');
                }
            }
        }
    }

    updateStickyAddToCart(unavailable = true, disable = true){
        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const itemImage = sticky.find('.sticky-image');
            const option = sticky.find('variant-sticky-selects .select__select').first();
            const input = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('input[name="id"]');
            const button = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
            const stickyTriggerButton = document.getElementById('show-sticky-product');
            const stickyPrice = sticky.find('.sticky-price');
            const stickyDynamicCheckoutWrapper = sticky.find('[data-dynamic-checkout-wrapper]');
            var quantityInput = this.item.find('input[name="quantity"]');
            var submitBtn = $('.product-form__submit');
            var maxValue;

            if (quantityInput.length > 0) {
                maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
            } else {
                maxValue = parseInt(submitBtn.attr('data-inventory-quantity'));
            }
          
            if(unavailable){
                const noVariantSelected = !this.currentVariant?.id;
                var text = noVariantSelected
                    ? (window.variantStrings?.selectVariant || window.variantStrings?.select || 'Please select a variant')
                    : window.variantStrings.unavailable;

                if (button) {
                    button.setAttribute('disabled', true);
                    button.textContent = text;
                }

                if (stickyTriggerButton) {
                    stickyTriggerButton.textContent = text;
                }

                if (option.length && noVariantSelected && option.find('option[value=""]').length) {
                    option.val('');
                    option[0].dispatchEvent(new Event('change', { bubbles: true }));
                }

                if (input) {
                    input.value = noVariantSelected ? '' : (this.currentVariant?.id || '');
                }

                if (stickyPrice.length) {
                    stickyPrice.toggle(!noVariantSelected);
                }
                if (stickyDynamicCheckoutWrapper.length && noVariantSelected) {
                    stickyDynamicCheckoutWrapper.hide();
                }
            } else {
                if (!this.currentVariant) return;

                const image = this.currentVariant?.featured_image;
                
                if (image != null) {
                    itemImage.find('img').attr({
                        'src': image.src,
                        'srcset': image.src,
                        'alt': image.alt
                    });
                }

                if (option.length) {
                    const currentStickyValue = option.val();
                    option.val(this.currentVariant.id);
                    if (currentStickyValue !== String(this.currentVariant.id)) {
                        option[0].dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
                if (stickyPrice.length) {
                    stickyPrice.show();
                }
                if (stickyDynamicCheckoutWrapper.length) {
                    stickyDynamicCheckoutWrapper.show();
                }

                if (disable) {
                    var text = window.variantStrings.soldOut;

                    button.setAttribute('disabled', true);
                    button.textContent = text;
                    if (stickyTriggerButton) {
                        stickyTriggerButton.textContent = text;
                    }
                } else {
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }

                    button.removeAttribute('disabled');
                    button.textContent = text;
                    if (stickyTriggerButton && window.subtotal.style != '2') {
                        stickyTriggerButton.textContent = text;
                    }
                }

                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    checkQuantityWhenVariantChange() {
        var quantityInput = this.closest('.productView-details').querySelector('input.quantity__input')
        var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
        var inputValue = parseInt(quantityInput?.value);

        let value = inputValue 

        if (inputValue > maxValue && maxValue > 0) {
            value = maxValue
        } else {
            value = inputValue
        }

        if (value < 1 || isNaN(value)) value = 1 
      
        if (quantityInput) {
          quantityInput.value = value
        }
        
        const elementProductAddToCart = document.getElementById('product-add-to-cart');
        if (elementProductAddToCart && this.currentVariant?.available !== undefined && typeof maxValue !== 'undefined') {
            elementProductAddToCart.dataset.available = this.currentVariant.available && maxValue <= 0;
        }
    }

    updateVariantStatuses() {
        const inputWrappers = this.getAllOptionWrappers();
        const baseSelections = this.getSelectionConstraints({ useImplicitHiddenDefaults: true });
        const variant_swatch = [...this.querySelectorAll('.product-form__swatch')];
        const firstVisibleWrapper = this.getVisibleOptionWrappers()[0] || null;
        const firstVisibleOptionIndex = firstVisibleWrapper ? this.getWrapperOptionIndex(firstVisibleWrapper) : 0;
        const firstVisibleValue = firstVisibleWrapper ? this.getWrapperSelectedValue(firstVisibleWrapper) : '';
        const selectedOptionOneVariants = firstVisibleValue
            ? this.variantData.filter((variant) => (variant.options || [])[firstVisibleOptionIndex] === firstVisibleValue)
            : this.variantData;

        inputWrappers.forEach((option) => {
            const headerEl = option.querySelector('[data-header-option]');
            const checked = option.querySelector(':checked');
            const checkedValue = checked?.getAttribute('value') || '';
            if (headerEl) {
                if (checked && checkedValue) {
                    headerEl.innerText = this.decodeOption(checkedValue) || checkedValue;
                } else {
                    // Set a custom message based on the option name
                    const label = option.querySelector('.form__label');
                    const labelText = (label?.textContent || '').toLowerCase();
                    
                    let defaultMessage = window.variantStrings?.selectVariant || window.variantStrings?.select || 'Please select a variant';
                    
                    if (labelText.includes('sticker') || labelText.includes('shape')) {
                        defaultMessage = 'Please select a sticker shape';
                    } else if (labelText.includes('size') || labelText.includes('cm')) {
                        defaultMessage = 'Please select a size';
                    } else if (labelText.includes('quantity') || labelText.includes('amount')) {
                        defaultMessage = 'Please select a quantity';
                    }

                    headerEl.innerText = defaultMessage;
                }
            }

            const optionIndex = this.getWrapperOptionIndex(option);
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const optionInputsValue = [];
            const availableOptionInputsValue = [];

            optionInputs.forEach((input) => {
                const rawValue = input.getAttribute('value');
                if (!rawValue) return;

                const candidateValue = this.decodeOption(rawValue);
                const candidateSelections = [...baseSelections];
                candidateSelections[optionIndex] = candidateValue;

                if (this.getMatchingVariants(candidateSelections).length > 0) {
                    optionInputsValue.push(rawValue);
                }

                if (this.getMatchingVariants(candidateSelections, { availableOnly: true }).length > 0) {
                    availableOptionInputsValue.push(rawValue);
                }
            });

            this.setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue);
            if (variant_swatch.length > 1) {
                this.updateImageSwatch(selectedOptionOneVariants);
            }
        });
    }

    updateOptionLabelsByMetafield() {
        try {
            const variantProps = this.getVariantPropertiesData() || {};
            const wrappers = this.getAllOptionWrappers();
            const current = this.getSelectionConstraints({ useImplicitHiddenDefaults: true });
            const variants = this.getVariantData();
            if (!variants || !variants.length) return;
            const hasVariantProps = Object.keys(variantProps || {}).length > 0;

            const guessQtyIndex = () => {
                const qtyWrapper = wrappers.find((wrapper) => wrapper.dataset.optionRole === 'quantity');
                if (qtyWrapper) {
                    return this.getWrapperOptionIndex(qtyWrapper);
                }

                const sample = variants?.[0]?.options || [];
                let idx = sample.findIndex(v => /quantity|pack|package|case|pcs|box/i.test(String(v || '')));
                if (idx !== -1) return idx;
                const isSizeLike = (val) => /\bcm\b|\bmm\b|\dx\s*\d/i.test(String(val || ''));
                if (sample.length >= 2 && !isSizeLike(sample[1])) return 1;
                return sample.length ? 0 : 0;
            };
            const qtyIndex = guessQtyIndex();

            const findMatch = (desired, optionIndex, optionValue) => {
                const desiredOptions = desired.slice();
                desiredOptions[optionIndex] = optionValue;
                let match = variants.find(v => {
                    const opts = v.options || [];
                    return opts.every((val, i) => !desiredOptions[i] || desiredOptions[i] === val);
                });
                if (!match) {
                    match = variants.find(v => v.options && v.options[optionIndex] === optionValue);
                }
                return match || null;
            };

            const getUnitText = (variant, qtyKey, fallbacks) => {
                if (!variant || !variantProps[variant.id]) return null;
                const map = variantProps[variant.id];
                if (qtyKey && Object.prototype.hasOwnProperty.call(map, qtyKey)) return map[qtyKey];
                if (Array.isArray(fallbacks)) {
                    const foundKey = fallbacks.find(k => k && Object.prototype.hasOwnProperty.call(map, k));
                    if (foundKey) return map[foundKey];
                }
                return null;
            };

            const qtySelectVal = wrappers[qtyIndex]?.querySelector('select')?.value || current[qtyIndex] || '';

            wrappers.forEach((wrap, idx) => {
                const sel = wrap.querySelector('select');
                if (!sel) return;
                const options = Array.from(sel.options);

                options.forEach((opt) => {
                    if (!opt.value) return;
                    const match = findMatch(current, idx, opt.value);
                    const qtyKey = idx === qtyIndex ? opt.value : qtySelectVal;
                    const unitText = getUnitText(match, qtyKey, [qtyKey, opt.value, ...current.filter(Boolean)]);
                    if (unitText) {
                        opt.dataset.metafieldValue = unitText;
                    } else if (hasVariantProps) {
                        delete opt.dataset.metafieldValue;
                    }
                });

                sel.dispatchEvent(new CustomEvent('dropdown:options-updated', { bubbles: true }));
            });
        } catch (e) {
            console.error('Error in updateOptionLabelsByMetafield:', e);
        }
    }

    getVariantPropertiesData() {
        if (this._variantPropertiesCache) return this._variantPropertiesCache;
        let el = this.querySelector('script[data-variant-properties]');
        if (!el) {
            // In some themes, the script can be moved outside variant-selects; search the whole document
            el = document.querySelector('variant-selects script[data-variant-properties], script[data-variant-properties]');
        }
        if (!el) return null;
        try {
            const json = JSON.parse(el.textContent || '{}');
            this._variantPropertiesCache = json;
            return json;
        } catch (e) {
            return null;
        }
    }

    updateImageSwatch(selectedOptionOneVariants) {
        const inputWrappers = this.getAllOptionWrappers();
        if(inputWrappers){
            inputWrappers.forEach((element) => {
                const optionIndex = this.getWrapperOptionIndex(element);
                const imageSpan = element.querySelectorAll("label>span.pattern");
                const imageLabel = element.querySelectorAll("label");
                const imageSpanImage = element.querySelectorAll("label>span.expand>img");
                const inputList = element.querySelectorAll("input");

                inputList.forEach((item, index) => {
                    const image = selectedOptionOneVariants.filter(tmp => {
                        return (tmp.options || [])[optionIndex] == item.value;
                    });
    
                    if(image.length > 0) {
                        imageLabel[index].style.display = "inline-block";
                        if (imageSpan[index] != undefined && image[0].featured_image != null) imageSpan[index].style.backgroundImage = `url("${image[0].featured_image.src}")`;
                        if (imageSpanImage[index] != undefined && image[0].featured_image != null) imageSpanImage[index].srcset = image[0].featured_image.src;
                    }
                })
            });
        }
    }            

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            const value = input.getAttribute('value');
            if (!value) return;

            const isAvailable = availableOptionInputsValue.includes(value);
            const isPossible = optionInputsValue.includes(value);

            if (isAvailable) {
                input.classList.remove('soldout');
            } else {
                input.classList.add('soldout');
            }

            if (input.tagName === 'OPTION') {
                input.classList.toggle('unavailable', !isPossible);
                input.disabled = !isAvailable;
            }
        });
    }

    updateBadgeSale() {
        let badgeWrap = document.querySelector(".productView-badge");

        if (!badgeWrap) return;

        let badgeText = badgeWrap.querySelector(".productView-badge .badge.sale-badge"),
            badgeTextSaleType = badgeWrap.getAttribute('data-text-sale-badge'),
            priceCompare = document.querySelector(".productView-product .price__compare").getAttribute('data-compare'),
            priceLast = document.querySelector(".productView-product .price__sale .price__last").getAttribute('data-last'),
            percentSale = Math.round(((priceCompare - priceLast) / priceCompare) * 100);

        function renderSpan(text1, text2) {
            let spanElement = document.createElement('span');
            spanElement.classList.add('badge', 'sale-badge');
            let container = document.querySelector('.productView-badge');
            container.appendChild(spanElement);
            spanElement.innerText = `${text1} ${text2}%`
        }

        if (badgeWrap.classList.contains("has-badge-js")) {
            if (!priceCompare) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
            } else {
                if (!badgeText) {
                    renderSpan(badgeTextSaleType, percentSale)
                } else {
                    badgeText.innerText = `${badgeTextSaleType} ${percentSale}%`
                }
            }
        } else {
            if (!priceCompare) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
            } else {
                if (!badgeText) {
                    renderSpan(badgeTextSaleType, percentSale);
                } else {
                    badgeText.innerText = `${badgeTextSaleType}`
                }
            }
        }
    }

    // Stock check and dropdown disabling function
    checkStockAndDisableDropdowns() {
        const variants = this.getVariantData();
        const hasAnyStock = variants && variants.some(variant => variant.available);
        
        if (!hasAnyStock) {
            // No stock at all - disable all dropdowns
            this.querySelectorAll('select').forEach(select => {
                select.disabled = true;
                select.style.opacity = '0.5';
                select.style.cursor = 'not-allowed';
                
                // Use the stock message as the select placeholder
                const firstOption = select.querySelector('option:first-child');
                if (firstOption) {
                    firstOption.textContent = 'Out of stock';
                }
            });
            
            // Disable the add-to-cart button
            const addToCartBtn = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
            if (addToCartBtn) {
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = 'Out of stock';
                addToCartBtn.style.opacity = '0.5';
                addToCartBtn.style.cursor = 'not-allowed';
            }
            
            // Add stock warning message
            this.addStockWarningMessage();
        }
    }
    
    // Add stock warning message
    addStockWarningMessage() {
        const productView = this.closest('.productView');
        const existingMessage = productView?.querySelector('.stock-warning-message');
        if (existingMessage) return; // Already exists
        
        const warningMessage = document.createElement('div');
        warningMessage.className = 'stock-warning-message';
        warningMessage.style.cssText = `
            background: #fef2f2;
            border: 1px solid #fecaca;
            color: #dc2626;
            padding: 12px 16px;
            border-radius: 8px;
            margin: 15px 0;
            font-size: 14px;
            font-weight: 500;
            text-align: center;
        `;
        warningMessage.innerHTML = 'This product is currently out of stock.';
        
        // Add above the product form
        const productForm = this.closest('.product-form') || productView?.querySelector('.product-form');
        if (productForm) {
            productForm.insertBefore(warningMessage, productForm.firstChild);
        }
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            const label = input.nextElementSibling;
            if (!label) return;

            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                label.classList.remove('soldout', 'unavailable');
                label.classList.add('available');
            } else {
                label.classList.remove('available', 'unavailable');
                label.classList.add('soldout');

                if (window.variantStrings.hide_variants_unavailable && !optionInputsValue.includes(input.getAttribute('value'))) {
                    label.classList.add('unavailable')
                    if (!input.checked) return;
                    let inputsValue;
                    availableOptionInputsValue.length > 0 ? inputsValue = availableOptionInputsValue : inputsValue = optionInputsValue;
                    input.closest('.product-form__input').querySelector(`input[value="${inputsValue[0]}"]`).checked = true;
                    this.dispatchEvent(new Event('change'))
                }
            }
        });
    }
        
    updateOptions() {
        this.options = this.getAllOptionWrappers().map((wrapper) => this.getWrapperSelectedValue(wrapper) || '');
    }
}

customElements.define('variant-radios', VariantRadios);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        if (this.closest('.quick-order-list__contents')) return; 
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (!this.checkHasMultipleVariants()) {
            this.initProductQuantity();
            this.checkVariantInventory();
        }
    }

    onInputChange(event) {
        event.preventDefault(); 
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        var currentId = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="id"]')?.value;
        var saleOutStock  = document.getElementById('product-add-to-cart')?.dataset.available === 'true' || false ;
        const addButton = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');

        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }
        
        if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
            var arrayInVarName = `selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];
          
            if(itemStatus == 'deny') {
              inputValue = maxValue
              this.input.value = inputValue;
              const message = getInputMessage(maxValue)
              showWarning(message, 3000)
            }
        } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
            this.input.value = inputValue;
        }

        if(window.subtotal.show) {
            var text,
                price = this.input.dataset.price,
                subTotal = 0;

            subTotal = inputValue * price;
            subTotal = Shopify.formatMoney(subTotal, window.money_format);
            subTotal = extractContent(subTotal);

            const moneySpan = document.createElement('span')
            moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal') 
            moneySpan.innerText = subTotal 
            document.body.appendChild(moneySpan) 

            if (this.checkNeedToConvertCurrency()) {
                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }

            subTotal = moneySpan.innerText 
            $(moneySpan).remove()

            if (window.subtotal.style == '1') {
                const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');

                pdView_subTotal.textContent = subTotal;
            }
            else if (window.subtotal.style == '2') {
                text = window.subtotal.text.replace('[value]', subTotal);
                $('#product-sticky-add-to-cart').text(text);
                if (addButton != null){
                    addButton.textContent = text;
                }
            }

            const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
            const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

            if (stickyPrice.length) {
                stickyPrice.text(subTotal);
            }

            if (stickyComparePrice.length && window.subtotal.show) {
                let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
                comparePrice = inputValue * comparePrice;
                comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                comparePrice = extractContent(comparePrice);
                stickyComparePrice.text(comparePrice);
            }
        }

        if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
            const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
            if (mainQty != null){
                mainQty.value = inputValue;
            }

            const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
            const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

            if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
                const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
                mainQty3.value = inputValue;
            }
            else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
                const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
                mainQty2.value = inputValue;
            }
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    checkNeedToConvertCurrency() {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    }
    
    checkHasMultipleVariants() {
        const arrayInVarName = `product_inven_array_${this.querySelector('[data-product]').dataset.product}`
        this.inven_array = window[arrayInVarName];
        return Object.keys(this.inven_array).length > 1
    }
        
    initProductQuantity() {
        if(this.inven_array != undefined) {
            var inven_num = Object.values(this.inven_array),
                inventoryQuantity = parseInt(inven_num);

            this.querySelector('input[name="quantity"]').setAttribute('data-inventory-quantity', inventoryQuantity);
            this.querySelector('input[name="quantity"]').dataset.inventoryQuantity = inventoryQuantity
        }
    }

    checkVariantInventory() {
        const addBtn = document.getElementById('product-add-to-cart');
        if (!addBtn) return;
        this.input.disabled = addBtn.disabled;
        this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled;
        this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled;
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector('.product-option [type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('quantity-input', QuantityInput);



function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('kutufix-warning-popup').querySelector('[data-kutufix-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}
